
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { jwtDecode } from 'jwt-decode';
import { DecodedJwt } from 'shared/types/auth';


interface AuthState {
  user: DecodedJwt | null;
  isAuthenticated: boolean;
}

const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
};


const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action: PayloadAction<string>) => {
      const token = action.payload;
      localStorage.setItem('accessToken', token);
      window.dispatchEvent(new Event("storage"));
      try {
        const decoded = jwtDecode<DecodedJwt>(token);
        state.user = decoded;
        state.isAuthenticated = true;
      } catch {
        state.user = null;
        state.isAuthenticated = false;
      }
    },
    logout: (state) => {
        localStorage.removeItem('accessToken');
        window.dispatchEvent(new Event("storage"));
        state.user = null;
        state.isAuthenticated = false;
    },
    hydrateAuth: (state) => {
      const token = localStorage.getItem('accessToken');
      if (token) {
        try {
          const decoded = jwtDecode<DecodedJwt>(token);
          if (decoded.exp * 1000 > Date.now()) {
            state.user = decoded;
            state.isAuthenticated = true;
          } else {
            localStorage.removeItem('accessToken');
            window.dispatchEvent(new Event("storage"));
            state.user = null;
            state.isAuthenticated = false;
          }
        } catch {
            localStorage.removeItem('accessToken');
            window.dispatchEvent(new Event("storage"));
            state.user = null;
            state.isAuthenticated = false;
        }
      }
    },
  },
});

export const { setCredentials, logout, hydrateAuth } = authSlice.actions;
export default authSlice.reducer;